import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import { USER_ROLES } from 'shared/userRoles';
import { getUserLS } from 'shared/localStorage';

import PlayerCard from './PlayerCard/PlayerCard';

import styles from './PlayCardSearch.module.scss';
import FlagWrapper from "../../../../../Wrappers/LibWrappers/FlagWrapper";

const PlayCardSearch = ({
    level_progress,
    rating,
	level,
	username,
	country,
	id
}) => {
	const [colors, setColors] = useState({});
	const [sreenWidth] = useState(window.innerWidth);
	const [loggedUser] = useState(JSON.parse(getUserLS()));

	const setCardColor = () => {
		switch (level) {
			case USER_ROLES.BEGINNER:
				return { color1: '#3dbb75', color2: '#bedf79' };
			case USER_ROLES.CASUAL:
				return { color1: '#099d90', color2: '#08e5a7' };
			case USER_ROLES.CLUB:
				return { color1: '#104f9f', color2: '#0bbebf' };
			case USER_ROLES.LEAGUE:
				return { color1: '#614bef', color2: '#113e9a' };
			case USER_ROLES.TOURNAMENT:
				return { color1: '#73116f', color2: '#732ede' };
			case USER_ROLES.ADVANCED:
				return { color1: '#b64952', color2: '#761164' };
			case USER_ROLES.EXPERT:
				return { color1: '#bfb050', color2: '#be4f4f' };
			case USER_ROLES.MASTER:
				return { color1: '#847B42', color2: '#C6C880' };
			default:
				return { color1: '#3dbb75', color2: '#bedf79' };
		}
	};

	const calcWidth = () => {
		switch (true) {
			case sreenWidth < 1439:
				return 150;
			case sreenWidth < 1920:
				return 166;
			case 1920 < sreenWidth:
				return 200;

			default:
				return 166;
		}
	};

	useEffect(() => {
		setColors(setCardColor());
	}, [level]);

	const content = (
		<div className={styles.card_play_vs}>
			<PlayerCard
				sreenWidth={sreenWidth}
				level_progress={level_progress}
				level={level}
				width={calcWidth()}
				imageSize={calcWidth() - 36}
				user_badge_width={50}
				user_badge_position={-25}
				trailColor={'#0E0E0E'}
				colors={colors}
			/>
			<div className={styles.play_card_info}>
				<div>
					{username && username}
				</div>
				<div>
					{country &&
						<FlagWrapper
							countryCode={country}
							style={{
								width: '28px',
								height: '18px',
							}}
						/>
					}
					<span>{rating && `${rating} KS`}</span>
				</div>
			</div>
		</div>
	);

	return (
        loggedUser ?
		<Link to={`/profile/${id}`} className={styles.card_play_content}>
			{content}
		</Link> :
		<div className={styles.card_play_content}>
			{content}
		</div>
    );
};

export default PlayCardSearch;
